import { createApp } from 'vue';
import { startErrorReporting } from '../../resources/js/lib/errorReporting';
import App from './App.vue';
import './styles.css';

const app = createApp(App);
startErrorReporting(app, 'miniapp');
app.mount('#app');
